module.exports = __webpack_public_path__ + "static/img/zyzwx.4f2ddc1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/images/zyzwx.jpeg
// module id = Rnkn
// module chunks = 26